import { request } from '@/shared/api/request'

export const getEmployerActivityByBIN = (params) => {
	return request({ url: 'contract/universalMethods/requestUlData', method: 'GET', params })
}
